import React from 'react';
import s from './Price.scss';
import { data } from '../../../../globals';
import {
  isLocalCurrencyOnRight,
  isLocalCyrillic,
} from '../../../../services/window-utils';
import { formatNumber } from '../../../../constants';
import classNames from 'classnames';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';

import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

interface PriceProps extends InjectedExperimentsProps, WithTranslation {
  amount: number;
  currency?: string;
  discountAmount?: number;
}

const Price = (props: PriceProps) => {
  const { amount, discountAmount, currency, t } = props;
  const { decimalSeparator, groupSeparator } = data.currency;
  const amountWithSeparators = formatNumber(
    amount,
    decimalSeparator,
    groupSeparator,
  );
  const rightCurrency = isLocalCurrencyOnRight() ? currency : ' ';
  const leftCurrency = !isLocalCurrencyOnRight() ? currency : null;
  const formattedAmount = isLocalCurrencyOnRight()
    ? `${amountWithSeparators}${currency}`
    : `${currency}${amountWithSeparators}`;

  return (
    <div className={s.root} data-hook="highlights-price-component">
      <div className={classNames(s.price)} data-hook="highlights-price">
        <div
          className={s.currencyLeft}
          data-hook="highlights-price-currency-left"
        >
          {leftCurrency}
        </div>
        <div
          className={classNames(s.amount, {
            [s.isLocalCyrillic]: isLocalCyrillic(),
          })}
          data-hook="highlights-price-amount"
        >
          {discountAmount ? discountAmount : amountWithSeparators}
        </div>
        <div>
          <div
            className={s.currencyRight}
            data-hook="highlights-price-currency-right"
          >
            {rightCurrency}
          </div>
          <div className={s.aMonth} data-hook="highlights-price-aMonth">
            {t('highlights.price.aMonth')}
          </div>
        </div>
      </div>
      <div className={s.discountPrice} data-hook="highlights-price-original">
        {discountAmount ? formattedAmount : null}
      </div>
    </div>
  );
};

export default withTranslation()(withExperiments(Price));
